import { graphql, useStaticQuery, withPrefix } from "gatsby";
import React, { useMemo } from "react";
import JsonLd from "./json-ld";

const GATSBY_SITE_URL = process.env.GATSBY_SITE_URL;

const generateMetadata = (liferaySchemaOrgHp, description) => {
  if (!liferaySchemaOrgHp) return null;
  const {
    name,
    parentOrganization,
    social,
    streetAddress,
    addressLocality,
    addressCountry,
    telephone,
    areaServed,
  } = liferaySchemaOrgHp;
  const siteUrl = `${
    GATSBY_SITE_URL.endsWith("/") ? GATSBY_SITE_URL.slice(1) : GATSBY_SITE_URL
  }${withPrefix("/")}`;
  return {
    "@context": "https://schema.org",
    "@type": "ElectronicsStore",
    "name": name,
    "image": `${siteUrl}logo.svg`,
    "url": siteUrl,
    "sameAs": social,
    "parentOrganization": parentOrganization,
    ...(description ? { description } : null),
    ...(telephone ? { telephone: telephone } : null),
    "address": {
      "@type": "PostalAddress",
      "streetAddress": streetAddress,
      "addressLocality": addressLocality,
      "addressCountry": addressCountry,
    },
    "areaServed": areaServed,
  };
};

const SiteOrgSchema = ({ description }) => {
  const { liferaySchemaOrgHp } = useStaticQuery(graphql`
    {
      liferaySchemaOrgHp {
        name
        parentOrganization
        social
        streetAddress
        addressLocality
        addressCountry
        telephone
        areaServed
      }
    }
  `);
  const jsonLdData = useMemo(
    () => generateMetadata(liferaySchemaOrgHp, description),
    [liferaySchemaOrgHp, description]
  );

  return <JsonLd data={jsonLdData} />;
};

export default SiteOrgSchema;
